import React, { useEffect, useState } from 'react';
import Desktop from './desktop';
import Mobile from './mobile';
import useComponent from './useComponent';

const Login = () => {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < 992;
  });

  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const viewModel = useComponent();

  return isMobile ? <Mobile viewModel={viewModel} /> : <Desktop viewModel={viewModel} />;
};

export default Login;
